module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x40_small-9b325b502db22b69dbf1ec56e76f9ef6.png";